import React from "react";
import { getClassNames } from "../../../utils";

function CellWithMessageTitle({
    isRead = false,
    title = null,
    recipients = null,
}) {
    const className = getClassNames("table-cell_with_message", {
        "table-cell_with_message-new": !isRead,
    });

    return (
        <div className={className}>
            <b>{recipients}</b>
            <p data-isread={isRead}>{title}</p>
        </div>
    );
}


export default CellWithMessageTitle;
